import { useEffect, useState } from 'react';
import { Card } from '../../components/ui/card';
import { Loader2 } from 'lucide-react';
import api from '../../lib/api';

const shade = (n, max) => (!n ? 'text-slate-300' : n >= max * 0.66 ? 'bg-blue-600 text-white' : n >= max * 0.33 ? 'bg-blue-200 text-blue-900' : 'bg-blue-50 text-blue-800');

export const CbtTrend = () => {
  const [d, setD] = useState(null);
  useEffect(() => { api.get('/callback-tracker/trend', { params: { days: 14 } }).then(r => setD(r.data)).catch(() => setD({ dates: [], rows: [] })); }, []);
  if (!d) return <div className="py-16 text-center text-slate-400"><Loader2 className="w-5 h-5 animate-spin inline" /></div>;
  const max = Math.max(1, ...d.rows.flatMap(r => Object.values(r.days)));
  return (
    <Card className="p-4" data-testid="cbt-trend-table">
      <h3 className="text-sm font-bold text-slate-900">Calls per user per day</h3>
      <p className="text-[11px] text-slate-500 mb-3">Last 14 days, calls on leads that are in Call Back now. Darker = more calls; blank days show gaps in follow-up.</p>
      <div className="overflow-x-auto">
        <table className="w-full text-xs">
          <thead className="text-[10px] text-slate-400"><tr><th className="text-left py-1 uppercase tracking-wider">User</th>
            {d.dates.map(x => <th key={x} className="text-center font-medium px-0.5">{new Date(`${x}T00:00:00`).toLocaleDateString('en-IN', { day: 'numeric', month: 'short' })}</th>)}
            <th className="text-right uppercase tracking-wider">Total</th></tr></thead>
          <tbody>
            {d.rows.length === 0 && <tr><td colSpan={d.dates.length + 2} className="py-8 text-center text-slate-400">No calls yet.</td></tr>}
            {d.rows.map(r => (
              <tr key={r.user} className="border-t border-slate-100" data-testid={`cbt-trend-${r.user.replace(/[^a-zA-Z0-9]/g, '-')}`}>
                <td className="py-1.5 font-medium text-slate-800 whitespace-nowrap pr-2">{r.user}</td>
                {d.dates.map(x => <td key={x} className="px-0.5 py-0.5"><div className={`rounded text-center py-1 ${shade(r.days[x] || 0, max)}`}>{r.days[x] || '·'}</div></td>)}
                <td className="text-right font-bold pl-2">{r.total}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </Card>
  );
};
